export const ROUTE_PATHS = {
  HOME: '/',
} as const;

export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  publishedAt: string;
  author: string;
  readTime: string;
  category: string;
  tags: string[];
  imageUrl: string;
}

export interface HeadshotGenerator {
  id: string;
  name: string;
  description: string;
  pricing: string;
  features: string[];
  pros: string[];
  cons: string[];
  rating: number;
  imageUrl: string;
  url: string;
}

export const HEADSHOT_GENERATORS: HeadshotGenerator[] = [
  {
    id: 'aragon-ai',
    name: 'Aragon.ai',
    description: 'Premium AI headshot generator with studio-quality results and fast turnaround',
    pricing: '$29-$99',
    features: [
      'Multiple style options',
      '40+ professional headshots',
      '90-minute turnaround',
      'High-resolution outputs',
      'Privacy protection',
    ],
    pros: [
      'Exceptional photorealism',
      'Fast processing time',
      'Wide variety of styles',
      'Professional lighting',
    ],
    cons: [
      'Higher price point',
      'Requires 12+ input photos',
    ],
    rating: 4.8,
    imageUrl: '',
    url: 'https://aragon.ai',
  },
  {
    id: 'headshotpro',
    name: 'HeadshotPro',
    description: 'AI-powered professional headshots with corporate focus and team packages',
    pricing: '$29-$79',
    features: [
      'Corporate style focus',
      '120+ headshot variations',
      '2-hour processing',
      'Team packages available',
      'Satisfaction guarantee',
    ],
    pros: [
      'Excellent for corporate use',
      'Consistent brand look',
      'Team discounts',
      'Money-back guarantee',
    ],
    cons: [
      'Limited creative styles',
      'Longer processing time',
    ],
    rating: 4.7,
    imageUrl: '',
    url: 'https://headshotpro.com',
  },
  {
    id: 'betterpic',
    name: 'BetterPic',
    description: 'Affordable AI headshots with natural results and quick delivery',
    pricing: '$25-$69',
    features: [
      'Natural lighting',
      '100+ headshot options',
      '1-hour turnaround',
      'Multiple backgrounds',
      'Batch processing',
    ],
    pros: [
      'Competitive pricing',
      'Natural-looking results',
      'Fast delivery',
      'Easy to use',
    ],
    cons: [
      'Fewer style options',
      'Basic editing features',
    ],
    rating: 4.6,
    imageUrl: '',
    url: 'https://betterpic.io',
  },
  {
    id: 'photopacks',
    name: 'PhotoPacks.AI',
    description: 'Budget-friendly AI headshots with good quality and variety',
    pricing: '$19-$49',
    features: [
      '50+ headshot styles',
      'Affordable pricing',
      '2-hour processing',
      'Multiple outfit options',
      'Background variety',
    ],
    pros: [
      'Best value for money',
      'Good variety',
      'Simple interface',
      'Quick setup',
    ],
    cons: [
      'Lower resolution options',
      'Less photorealistic',
    ],
    rating: 4.4,
    imageUrl: '',
    url: 'https://photopacks.ai',
  },
  {
    id: 'pixelbin',
    name: 'Pixelbin',
    description: 'Enterprise-grade AI headshot solution with advanced customization',
    pricing: '$49-$149',
    features: [
      'Advanced customization',
      'API access',
      'Bulk processing',
      'White-label options',
      'Priority support',
    ],
    pros: [
      'Enterprise features',
      'Highly customizable',
      'Scalable solution',
      'API integration',
    ],
    cons: [
      'Premium pricing',
      'Complex setup',
    ],
    rating: 4.5,
    imageUrl: '',
    url: 'https://pixelbin.io',
  },
];

export const ARTICLE_SECTIONS = [
  {
    id: 'introduction',
    title: 'The Rise of AI Headshot Generators in 2026',
    anchor: 'introduction',
  },
  {
    id: 'what-are',
    title: 'What Are AI Headshot Generators?',
    anchor: 'what-are',
  },
  {
    id: 'how-they-work',
    title: 'How AI Headshot Technology Works',
    anchor: 'how-they-work',
  },
  {
    id: 'top-generators',
    title: 'Top AI Headshot Generators Reviewed',
    anchor: 'top-generators',
  },
  {
    id: 'key-features',
    title: 'Key Features to Look For',
    anchor: 'key-features',
  },
  {
    id: 'use-cases',
    title: 'Professional Use Cases',
    anchor: 'use-cases',
  },
  {
    id: 'quality-factors',
    title: 'Quality Factors and Best Practices',
    anchor: 'quality-factors',
  },
  {
    id: 'pricing',
    title: 'Pricing and Value Comparison',
    anchor: 'pricing',
  },
  {
    id: 'conclusion',
    title: 'Conclusion and Recommendations',
    anchor: 'conclusion',
  },
] as const;
